export default __webpack_public_path__ + "static/media/plummet_io_crop.63ab3b9b.png";